<template>
  <v-stepper v-model="e1">
    <v-stepper-header>
      <v-stepper-step :complete="e1 > 1" step="1">Dados de contato</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2">Name of step 2</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step step="3">Name of step 3</v-stepper-step>
    </v-stepper-header>




    <v-stepper-items>
      <v-stepper-content step="1">
       <v-card flat>
		    <h1 class="fonte text-uppercase">Formulário de dados de contato</h1>
            <v-divider class="mt-3 mb-4"></v-divider>
		    <v-layout justify-space-between="justify-space-between" row="row" wrap="wrap" >
                <v-flex xs12 sm12 md12>
                    <v-text-field
                        label="Insira o seu CPF ou CNPJ"
                        box
                        prepend-inner-icon="insert_drive_file"
                        v-model="user.cpf_cpnj"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-text-field
                        label="Insira seu email"
                        box
                        prepend-inner-icon="email"
                        v-model="user.email"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12>
                    <v-text-field
                        label="Insira seu celular"
                        box
                        prepend-inner-icon="phone"
                        v-model="user.telefone"
                    ></v-text-field>
                </v-flex>
		    </v-layout>
        </v-card>

       <v-btn
            :loading="loaderDadosContato"
            :disabled="loaderDadosContato"
            class="white--text mb-3"
            style="background-color: #59BDB3"
            @click="onSendDadosContato()"
        >
            <v-icon left dark>send</v-icon>
            Entrar
            <template v-slot:loader>
                <span class="custom-loader">
                    <v-icon light>cached</v-icon>
                </span>
            </template>
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="2">
        <v-card
          class="mb-5"
          color="grey lighten-1"
          height="200px"
        ></v-card>

        <v-btn
          color="primary"
          @click="e1 = 3"
        >
          Continue
        </v-btn>

        <v-btn flat>Cancel</v-btn>
      </v-stepper-content>

      <v-stepper-content step="3">
        <v-card
          class="mb-5"
          color="grey lighten-1"
          height="200px"
        ></v-card>

        <v-btn
          color="primary"
          @click="e1 = 1"
        >
          Continue
        </v-btn>

        <v-btn flat>Cancel</v-btn>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    data () {
      return {
        e1: 0,
        loaderDadosContato: false,
        user: {
          nome: 'David',
          cep: '',
          telefone: '16996282955',
          logradouro: '',
          bairro: '',
          cidade: '',
          estado: '',
          email: 'deeh.programmer@outlook.com',
          senha:'123456',
          numero: '1101',
          senhaNovamente: '123456',
          cpf_cpnj: '43232819869',
          cod: ''
        },
      }
    },
    methods: {
      ...mapActions(['sendDadosContato']),
        async onSendDadosContato () {
          let r = await this.sendDadosContato(this.user)
          this.e1 = 2
        }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/CriarConta.vue